import store from '../../store';

export const createGetFilters = (storeKey) => store.get(`${storeKey}`);
export const createSetFilters = (storeKey) => store.create.set(`${storeKey}`);
